import React, { useState } from "react";
import { Link } from "react-router-dom";
import bg3 from "../../assect/images/bg/03.jpg";
import logo from "../../assect/images/logomobile.gif";
import { Oval } from 'react-loader-spinner';
import authService from "../../services/authService";

export default function ResetPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            await authService.forgotPassword(email);
            setSuccess(true);
        } catch (err) {
            setError(err.message || "Failed to process password reset request. Please try again.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="bg-home zoom-image d-flex align-items-center">
                // Start of Selection
                <div className="bg-overlay image-wrap" style={{background: "linear-gradient(to right, #3494E6, #EC6EAD)", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", backgroundPosition: 'center'}}></div>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="p-4 bg-white rounded-3 shadow-md mx-auto w-100" style={{maxWidth:'400px'}}>
                            {loading ? (
                                <div className="text-center py-4">
                                    <Oval
                                        visible={true}
                                        height="80"
                                        width="80"
                                        color="#4fa94d"
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    />
                                    <p className="mt-3">Processing your request...</p>
                                </div>
                            ) : success ? (
                                <div className="text-center py-4">
                                    <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success" style={{fontSize: '64px'}}></i>
                                    </div>
                                    <h5 className="mb-3">Reset Email Sent!</h5>
                                    <p>Please check your email for instructions to reset your password.</p>
                                    <div className="mt-4">
                                        <Link to="/auth-login" className="btn btn-primary">Return to Login</Link>
                                    </div>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <Link to="/"><img src={logo} className="mb-4 d-block mx-auto" alt="" style={{height:70}}/></Link>
                                    <h5 className="mb-3">Reset your password</h5>

                                    {error && (
                                        <div className="alert alert-danger" role="alert">
                                            {error}
                                        </div>
                                    )}

                                    <p className="text-muted">Please enter your email address. You will receive a link to create a new password via email.</p>
                                
                                    <div className="form-floating mb-3">
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            id="email" 
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="name@example.com"
                                            required
                                        />
                                        <label htmlFor="email">Email address</label>
                                    </div>
                    
                                    <button className="btn btn-primary w-100" type="submit">Send Reset Link</button>

                                    <div className="col-12 text-center mt-3">
                                        <span>
                                            <span className="text-muted me-2">Remember your password?</span> 
                                            <Link to="/auth-login" className="text-dark fw-medium">Sign in</Link>
                                        </span>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
